import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService, IdmApiService } from '../../../../../services';
import { CalculationType } from '../../../enums/calculation-type.enum';
import { GasketModel, GasketTypeModel } from '../../../models';
import { TreeFlatNode } from '../../../models/templatesModels/tree-flat-node';
import { TreeNode } from '../../../models/templatesModels/tree-node';
import { TighteningMethod } from '../../../enums/tightening-method.enum';
import { MeasurementService } from 'src/app/services/measurement.service';
import { UnitType } from 'src/app/models/enums/unit-type.enum';
import { ChangeEvent } from 'devextreme/ui/text_box';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';

@Component({
    selector: 'app-gasket',
    templateUrl: './gasket.component.html',
    styleUrls: ['./gasket.component.scss'],
})
export class GasketComponent implements OnInit, OnDestroy {
    @Input() enable: boolean;
    @Input()
    set standardId(value: string) {
        this._standardId = value;
        if (value) this.getGasketTypes();
        this.cd.markForCheck();
    }
    get standardId(): string {
        return this._standardId;
    }

    @Input()
    set flangeFacingTypeId(value: string) {
        // this.isRTJ = undefined;  // by Krima * if we not set this as undefined then it will call gasket api twice with different API so gasket list getting mismatched
        this._flangeFacingTypeId = value;
        if (value) {
            this.isRedirect =
                this.activatedRoute.snapshot.paramMap.get('isRedirect') == 'true' ||
                this.router.url == '/settings/idms' ||
                this.idmsSharedService.enableConfirmWithRouter(2) == true;
            if (!this.isRedirect) {
                this.form.get('gasket').reset(); // * in case of loading from matrix we don't need to reset gasket value
            }
            this.tempGasketValue = '';
            // if (!this.jointCalcService.isPipeCode) this.getAndLoadGasketTree();
        }
    }
    get flangeFacingTypeId(): string {
        return this._flangeFacingTypeId;
    }

    @Input()
    set pressureClassId(value: string) {
        this._pressureClassId = value;
    }
    get pressureClassId(): string {
        return this._pressureClassId;
    }

    @Input()
    set pipeSizeId(value: string) {
        this._pipeSizeId = value;
    }
    get pipeSizeId(): string {
        return this._pipeSizeId;
    }

    @Input()
    set isStandardFlange(value: boolean) {
        this._isStandardFlange = value;
        if (value && !this.jointCalcService.isPipeCode) this.getAndLoadGasketTree();
    }
    get isStandardFlange(): boolean {
        return this._isStandardFlange;
    }

    @Input()
    set isRTJ(value: boolean) {
        this._isRTJ = value;
        if (value !== undefined && !this.jointCalcService.isPipeCode) this.getAndLoadGasketTree();
        // this.cd.markForCheck();
    }
    get isRTJ(): boolean {
        return this._isRTJ;
    }

    @Input()
    set isCustom(value: boolean) {
        this._isCustom = value;
        if (value === true && !this.jointCalcService.isPipeCode) {
            this.getGasketTypes();
            this.getAndLoadGasketTree();
        }
    }
    get isCustom(): boolean {
        return this._isCustom;
    }

    @Input()
    set isEngineeredJoint(value: boolean) {
        this._isEngineeredJoint = value;
        if (value === true && !this.jointCalcService.isPipeCode) this.getAndLoadGasketTree();
    }
    get isEngineeredJoint(): boolean {
        return this._isEngineeredJoint;
    }

    @Input()
    set doGasketReset(value: boolean) {
        if (value) {
            this.tempGasketValue = '';
        }
    }
    @Input() form: UntypedFormGroup;
    destroy$ = new Subject();

    tooltip_position = 'above';
    isRedirect: boolean = false;
    closeResult: string;
    calculationType: number;
    tempGasketValue: string;
    loading: boolean = false;
    gasketList: GasketModel[] = [];
    gasketTypeList: GasketTypeModel[];
    tighteningMethod: number;
    selectedGasketResp: any;

    private gasketModalRef: NgbModalRef;
    private _transformer = (node: TreeNode, level: number) => {
        if (this.router.url == '/idms/plantmanager') {
            return {
                expandable: !!node.children && node.children.length > 0,
                name: node.name,
                id: node.id,
                level: level,
                typeId: node.typeId,
                typeName: node.typeName,
                alias: node.alias,
            };
        } else {
            return {
                expandable: !!node.children && node.children.length > 0,
                name: node.name,
                id: node.id,
                level: level,
                typeId: node.typeId,
                typeName: node.typeName,
            };
        }
    };
    treeControl = new FlatTreeControl<TreeFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );
    treeFlattener = new MatTreeFlattener(
        this._transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.children
    );
    treedataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    hasChild = (_: number, node: TreeFlatNode) => node.expandable;
    gasketnodeList: TreeNode[];

    private _standardId: string;
    private _flangeFacingTypeId: string;
    private _pressureClassId: string;
    private _pipeSizeId: string;
    private _isStandardFlange: boolean = false;
    private _isRTJ: boolean = false;
    private _isCustom: boolean = false;
    private _isEngineeredJoint: boolean = false;

    constructor(
        private iceapi: IceapiService,
        private modalService: NgbModal,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private globalEmittersService: GlobalEmittersService,
        private activatedRoute: ActivatedRoute,
        private measSvc: MeasurementService,
        private cd: ChangeDetectorRef,
        private router: Router,
        public idmsSharedService: IdmsSharedService,
        private jointCalcService: JointCalcService,
        private idmApi: IdmApiService
    ) {
        this.gasketnodeList = [];
    }

    ngOnInit(): void {
        this.form.markAllAsTouched();
        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithGasket();
        }
        this.globalEmittersService.currentCalculationType.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.calculationType = res;
        });

        this.form
            .get('gasket')
            ?.valueChanges.pipe(takeUntil(this.destroy$))
            ?.subscribe((value) => {
                if (this.form.get('gasket').value)
                    if (this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView'))
                        this.jointCalcService.selectedgasket.next(value);
            });

        this.form
            .get('enableAdvOp')
            ?.valueChanges.pipe(takeUntil(this.destroy$))
            ?.subscribe((val) => {
                if (val) {
                    this.getAndLoadGasketTree(CalculationType.OverriddenFlange);
                }
            });

        if (this.calculationType == CalculationType.StandardFlange) {
            this.form
                .get('enableOveride')
                .valueChanges.pipe(takeUntil(this.destroy$))
                .subscribe((res) => {
                    if (res) {
                        const selectedGasketIndex = this.gasketList.findIndex((gasket) => gasket.gasketId == this.form.get('gasket').value);
                        if (selectedGasketIndex !== -1) {
                            this.form
                                .get('minGasketStress')
                                .setValue(
                                    this.measSvc.format(this.gasketList[selectedGasketIndex].minimumGasketStress.toString(), UnitType.DefaultStressUnit, 2)
                                );
                            this.form
                                .get('maxGasketStress')
                                .setValue(
                                    this.measSvc.format(this.gasketList[selectedGasketIndex].maximumGasketStress.toString(), UnitType.DefaultStressUnit, 2)
                                );
                            this.form
                                .get('recGasketStress')
                                .setValue(
                                    this.measSvc.format(this.gasketList[selectedGasketIndex].recommendedGasketStress.toString(), UnitType.DefaultStressUnit, 2)
                                );
                            this.form.get('m').setValue(this.gasketList[selectedGasketIndex].m.toString());
                            this.form.get('y').setValue(this.measSvc.format(this.gasketList[selectedGasketIndex].y.toString(), UnitType.DefaultStressUnit, 2));

                            this.form
                                .get('isRecGasketStress')
                                .valueChanges.pipe(takeUntil(this.destroy$))
                                .subscribe((res) => {
                                    if (res) {
                                        this.form.get('recGasketStress').setValidators(Validators.required);
                                    } else {
                                        this.form
                                            .get('recGasketStress')
                                            .setValue(
                                                this.measSvc.format(
                                                    this.gasketList[selectedGasketIndex].recommendedGasketStress.toString(),
                                                    UnitType.DefaultStressUnit
                                                )
                                            );
                                        this.form.get('recGasketStress').clearValidators();
                                    }
                                });

                            this.form
                                .get('isMinGasketStress')
                                .valueChanges.pipe(takeUntil(this.destroy$))
                                .subscribe((res) => {
                                    if (res) {
                                        this.form.get('minGasketStress').setValidators(Validators.required);
                                    } else {
                                        this.form
                                            .get('minGasketStress')
                                            .setValue(
                                                this.measSvc.format(
                                                    this.gasketList[selectedGasketIndex].minimumGasketStress.toString(),
                                                    UnitType.DefaultStressUnit
                                                )
                                            );
                                        this.form.get('minGasketStress').clearValidators();
                                    }
                                });

                            this.form
                                .get('isMaxGasketStress')
                                .valueChanges.pipe(takeUntil(this.destroy$))
                                .subscribe((res) => {
                                    if (res) {
                                        this.form.get('maxGasketStress').setValidators(Validators.required);
                                    } else {
                                        this.form
                                            .get('maxGasketStress')
                                            .setValue(
                                                this.measSvc.format(
                                                    this.gasketList[selectedGasketIndex].maximumGasketStress.toString(),
                                                    UnitType.DefaultStressUnit
                                                )
                                            );
                                        this.form.get('maxGasketStress').clearValidators();
                                    }
                                });

                            this.form
                                .get('ism')
                                .valueChanges.pipe(takeUntil(this.destroy$))
                                .subscribe((res) => {
                                    if (res) {
                                        this.form.get('m').setValidators(Validators.required);
                                    } else {
                                        this.form.get('m').setValue(this.gasketList[selectedGasketIndex].m.toString());
                                        this.form.get('m').clearValidators();
                                    }
                                });

                            this.form
                                .get('isy')
                                .valueChanges.pipe(takeUntil(this.destroy$))
                                .subscribe((res) => {
                                    if (res) {
                                        this.form.get('y').setValidators(Validators.required);
                                    } else {
                                        this.form
                                            .get('y')
                                            .setValue(this.measSvc.format(this.gasketList[selectedGasketIndex].y.toString(), UnitType.DefaultStressUnit));
                                        this.form.get('y').clearValidators();
                                    }
                                });

                            if (this.tighteningMethod === TighteningMethod.Tension) {
                                this.form.get('pAdditional').setValue(this.gasketList[selectedGasketIndex].padditional.toString());
                            }
                        }
                    } else if (res == false) {
                        this.form.get('recGasketStress').reset('');
                        this.form.get('minGasketStress').reset('');
                        this.form.get('maxGasketStress').reset('');
                        this.form.get('m').reset('');
                        this.form.get('y').reset('');
                    }
                });

            this.globalEmittersService.tighteningMethod.pipe(takeUntil(this.destroy$)).subscribe((res) => {
                if (res.toLowerCase() === 'tension') {
                    this.tighteningMethod = TighteningMethod.Tension;
                    const selectedGasketIndex = this.gasketList.findIndex((gasket) => gasket.gasketId == this.form.get('gasket').value);
                    if (selectedGasketIndex !== -1) {
                        this.form.get('pAdditional').setValue(this.gasketList[selectedGasketIndex].padditional.toString());
                    }
                } else if (res.toLowerCase() === 'torque') {
                    this.tighteningMethod = TighteningMethod.Torque;
                }
            });

            // this.globalEmittersService.tighteningProcedureForm.pipe(takeUntil(this.destroy$)).subscribe((res: FormGroup) => {
            //   if(res){

            //     res.get('')
            //     const selectedGasketIndex = this.gasketList.findIndex((gasket) => gasket.gasketId == this.form.get('gasket').value);
            //     if(selectedGasketIndex !== -1){
            //       if(this.form.get('enableOveride').value)
            //          this.form.get('pAdditional').setValue(this.gasketList[selectedGasketIndex].padditional);
            //     }
            //   }
            // });
        }
        this.globalEmittersService.selectedGasketId.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.selectedGasketResp = res;
        });
    }
    async getAndLoadGasketTree(calcType?: number) {
        if (this.isEngineeredJoint) {
            this.getGasketTypes();
        }
        if (
            (this.flangeFacingTypeId !== undefined && this.isRTJ !== undefined && (this.isStandardFlange === true || this.isCustom === true)) ||
            this.isEngineeredJoint === true
        ) {
            this.loading = true;
            forkJoin([this.getGaskets(), this.getGasketTypes(calcType)])
                .pipe(takeUntil(this.destroy$))
                .subscribe(([response, response1]) => {
                    this.gasketList = response;
                    if (response1.success == true) {
                        this.gasketTypeList = response1.response;
                        if (this.dataService?.calculationData?.input?.recordId?.gasketId)
                            this.form.get('gasket').setValue(this.dataService?.calculationData?.input?.recordId?.gasketId);

                        if (this.form.get('gasket').value) {
                            this.dataService.selectedGasketMaterial = this.gasketList.find((x) => x.gasketId === this.form.get('gasket').value)?.qualifiedName;
                        }
                        this.cd.detectChanges();
                        this.createTreeStructure();
                    } else {
                        this.user_utility.errorModelPopup(response1.message);
                    }
                });
        }

        // ! OLD condition
        // if ((this.isStandardFlange === true && this.isRTJ !== undefined && this.flangeFacingTypeId !== undefined)
        //   || (this.isStandardFlange === false && this.standardId !== undefined)
        //   || (this.isCustom === true && this.flangeFacingTypeId !== undefined)
        //   || this.isEngineeredJoint === true) {
        //   this.loading = true;
        //   // this.gasketList = await this.getGaskets();
        //   forkJoin([this.getGaskets(),this.getGasketTypes()]).subscribe(([response,response1])=>{
        //     this.gasketList = response;
        //     if (response1.success == true) {
        //       this.gasketTypeList = response1.response;
        //       if (this.form.get('gasket').value) {
        //         this.dataService.selectedGasketMaterial = this.gasketList.find(x => x.gasketId === this.form.get('gasket').value).qualifiedName;
        //       }
        //       this.createTreeStructure();
        //     }
        //     else {
        //       this.user_utility.errorModelPopup(response1.message)
        //     }
        //   })
        // }
    }

    async getGaskets() {
        if (this.router.url != '/idms/plantmanager') {
            return this.iceapi
                .getGaskets(this.standardId, this.flangeFacingTypeId, this.pressureClassId, this.pipeSizeId, this.isStandardFlange, this.isRTJ, this.isCustom)
                .toPromise()
                .then((res) => {
                    if (res.success === true) {
                        return res.response;
                    } else {
                        this.user_utility.errorModelPopup(res.message);
                    }
                });
        } else {
            return this.idmApi
                .getCalcgetGaskets(
                    this.standardId,
                    this.flangeFacingTypeId,
                    this.pressureClassId,
                    this.pipeSizeId,
                    this.isStandardFlange,
                    this.isRTJ,
                    this.isCustom
                )
                .toPromise()
                .then((res) => {
                    if (res.success === true) {
                        return res.response;
                    } else {
                        this.user_utility.errorModelPopup(res.message);
                    }
                });
        }
    }

    getGasketTypes(calcType?: number): Observable<{ success?: boolean; isCustom?: boolean; message?: string; response?: GasketTypeModel[] }> {
        return this.iceapi.getGasketTypes(
            this.standardId,
            this.pressureClassId,
            this.flangeFacingTypeId,
            this.pipeSizeId,
            this.isRTJ,
            calcType ? calcType : this.isStandardFlange ? CalculationType.StandardFlange : this.isCustom ? CalculationType.CustomFlange : null
        );
    }

    createTreeStructure() {
        this.gasketnodeList = [];
        for (var gasket of this.gasketList) {
            let leafNode: TreeNode = {
                name: gasket.gasketName,
                id: gasket.gasketId,
                typeId: gasket.gasketType.gasketTypeId,
                typeName: gasket.gasketType.gasketTypeName,
                alias: gasket?.alias?.alias,
            };
            //This check is for Default value set either on redirect from Matrix or using default
            if (this.form.get('gasket').value !== '' && this.form.get('gasket').value == leafNode.id) {
                this.setFormValues(leafNode);
            }

            if (gasket.gasketType.parentGasketTypeId == null) {
                let treeNode = this.gasketnodeList.find((x) => x.typeId == gasket.gasketType.gasketTypeId);

                if (treeNode == undefined) {
                    treeNode = { name: gasket.gasketType.gasketTypeName, typeId: gasket.gasketType.gasketTypeId, children: [leafNode] };
                    this.gasketnodeList.push(treeNode);
                } else {
                    treeNode.children.push(leafNode);
                }
            } else {
                let parent = this.gasketTypeList.find((x) => x.gasketTypeId == gasket.gasketType.parentGasketTypeId);

                let parentNode = this.gasketnodeList.find((x) => x.typeId == parent?.gasketTypeId);
                if (parentNode == undefined) {
                    let treeNode = { name: gasket.gasketType.gasketTypeName, typeId: gasket.gasketType.gasketTypeId, children: [leafNode] };
                    //when no Gasket type avaible than it skips
                    if (parent?.gasketTypeName != undefined) {
                        parentNode = { name: parent?.gasketTypeName, typeId: parent?.gasketTypeId, children: [treeNode] };
                        this.gasketnodeList.push(parentNode);
                    }
                } else {
                    let treeNode1 = parentNode.children.find((x) => x.typeId == gasket.gasketType.gasketTypeId);

                    if (treeNode1 == undefined) {
                        treeNode1 = { name: gasket.gasketType.gasketTypeName, typeId: gasket.gasketType.gasketTypeId, children: [leafNode] };
                        parentNode.children.push(treeNode1);
                    } else {
                        treeNode1.children.push(leafNode);
                    }
                }
            }
        }
        this.loading = false;
        this.treedataSource.data = this.gasketnodeList;
        this.cd.detectChanges();
    }

    selectedGasket(node) {
        this.doGasketReset = false;
        this.setFormValues(node);
        this.form.get('gasket').setValue(node.id);

        this.treeControl.collapseAll();
        // this.modalService.dismissAll();
        if (this.gasketModalRef) {
            this.gasketModalRef.close();
        }
        this.dataService.selectedGasketMaterial = this.gasketList.find((x) => x.gasketId === node.id)?.qualifiedName;
        // * setting up values for min/max gasket stress, m , y
        let selectedGasketObj = this.gasketList.find((gasket) => gasket.gasketId == node.id);
        if (this.calculationType == CalculationType.CustomFlange) {
            this.form.get('minGasketStress').setValue(this.measSvc.format(selectedGasketObj.minimumGasketStress.toString(), UnitType.DefaultStressUnit, 2));
            this.form.get('maxGasketStress').setValue(this.measSvc.format(selectedGasketObj.maximumGasketStress.toString(), UnitType.DefaultStressUnit, 2));
            this.form.get('m').setValue(selectedGasketObj.m.toString());
            this.form.get('y').setValue(this.measSvc.format(selectedGasketObj.y.toString(), UnitType.DefaultStressUnit, 2));
        }
        this.globalEmittersService.selectedGasket.next(this.gasketList.find((gasket) => gasket.gasketId == node.id));
        this.globalEmittersService.selectedGasketId.next(node.id);
        if (selectedGasketObj?.alias?.materialAliasId) {
            this.dataService.gasketAliasId = selectedGasketObj?.alias?.materialAliasId;
            this.form.get('gasketAliasId')?.setValue(selectedGasketObj?.alias?.materialAliasId);
        }
    }

    closeModal() {
        this.treeControl.collapseAll();
        // this.modalService.dismissAll();
        if (this.gasketModalRef) {
            this.gasketModalRef.close();
        }
    }

    toggleOthers(node: TreeFlatNode) {
        if (node.level == 0) {
            if (this.treeControl.isExpanded(node)) {
                this.treeControl.collapseAll();
                this.treeControl.expand(node);
            } else {
                this.treeControl.collapseAll();
            }
        }
        if (node.level == 1 && node.expandable == true) {
            //TODO: Level 1 toggling
        }
    }

    setFormValues(node: TreeNode) {
        this.tempGasketValue = node.typeName + ' - ' + node.name;

        if (!this.isEngineeredJoint) {
            this.form.get('gasketType').setValue(node.typeId);
            this.form.get('gasketDiagramId').setValue(this.gasketList.find((x) => x.gasketId === node.id)?.diagramId);
            this.dataService.selectedGasketMaterial = this.gasketList.find((x) => x.gasketId === node.id).qualifiedName;
            this.cd.detectChanges();
        }
    }

    open(content) {
        // this.modalService.open(content, {
        //   ariaLabelledBy: 'modal-basic-title',
        //   backdrop: 'static',
        //   keyboard: false
        // }).result.then((result) => {
        //   this.closeResult = `Closed with: ${result}`;
        // }, (reason) => {
        //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        // });
        this.gasketModalRef = this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
            keyboard: false,
            size: 'xl',
        });
        this.gasketModalRef.result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    async pipespecwithGasket() {
        this.jointCalcService.selectedflangeMaterial.pipe(takeUntil(this.destroy$)).subscribe(async (fM) => {
            if (fM && this.jointCalcService.pipeSpecpayload.lookupParams.calculationType == CalculationType.StandardFlange) {
                let InputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;
                InputGroup.recordId.flangeMaterialId = fM;

                InputGroup.recordId.gasketId =
                    InputGroup.others.boltType =
                    InputGroup.recordId.boltMaterialId =
                    InputGroup.others.tighteningSpecification =
                        null;

                const [response, response1] = await forkJoin([this.getGaskets(), this.getGasketTypes()]).toPromise();
                this.gasketList = response;
                if (response1.success === true) {
                    this.gasketTypeList = response1.response;
                    this.gasketList = await this.jointCalcService.managePayloadForRecourdId('gasketId', this.gasketList);
                    if (this.form.get('gasket').value) {
                        this.dataService.selectedGasketMaterial = this.gasketList.find((x) => x.gasketId === this.form.get('gasket').value)?.qualifiedName;
                        this.cd.detectChanges();
                    }
                    if (this.dataService?.calculationData?.input?.recordId?.gasketId) {
                        this.form.get('gasket').setValue(this.dataService?.calculationData?.input?.recordId?.gasketId);
                        this.cd.detectChanges();
                    }
                    if (this.gasketList.length == 1) {
                        this.form.get('gasket').setValue(this.gasketList[0].gasketId);
                        this.cd.detectChanges();
                    }
                    if (this.dataService?.calculationData?.input?.recordId?.gasketAliasId) {
                        this.form.get('gasketAliasId')?.setValue(this.dataService?.calculationData?.input?.recordId?.gasketAliasId);
                    }

                    await this.createTreeStructure();
                }
                if (response1.success) {
                } else if (response1.isCustom) {
                    this.user_utility.errorModelPopup(response1.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
